class PageTabs {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.list = element.querySelector('.tabs');
    this.affixOffset = this.offset(this.element).top ?? null;
    this.links = this.element.querySelectorAll(".tabs__item a");
    this.scrollingElements = [];

    this.observer = new IntersectionObserver(this.intersectionCallback.bind(this), {
      rootMargin: "0px",
      threshold: 1.0,
    });

    this.initScrollingElementsArray();
    window.addEventListener("scroll", this.affixNav.bind(this), { passive: true });
  }

  initScrollingElementsArray() {
    if(!this.links){
      return [];
    }

    this.scrollingElements = Array.from(this.links)
      .map((link) => {
        const selector = link.getAttribute("href");
        const selectedElement = document.querySelector(selector) ?? false;

        if(selectedElement){
          selectedElement.relatedTab = link.parentElement;
          this.observer.observe(selectedElement);
        }

        return selectedElement;
      })
      .filter(Boolean);
  }

  intersectionCallback(entries, observer) {
    const visibleElements = Array.from(entries).filter((entry) => entry.isIntersecting);

    if(visibleElements.length){
      this.removeTabClass();
      visibleElements[0].target.relatedTab.classList.add("active");
      this.scrollToActiveTab(visibleElements[0].target.relatedTab);
    }
  }

  removeTabClass() {
    if(!this.links){
      return false;
    }

    this.links.forEach(el => el.parentElement.classList.remove('active'));
  }

  scrollToActiveTab(elem) {
    this.list.scrollLeft = elem.offsetLeft - 20;
  }

  affixNav() {
    if(window.scrollY > this.affixOffset){
      this.element.parentElement.classList.add("affixed-tabs");
    } else {
      this.element.parentElement.classList.remove("affixed-tabs");
    }
  }

  offset(el) {
    const box = el.getBoundingClientRect();
    const docElem = document.documentElement;

    return {
      top: (box.top + window.pageYOffset - docElem.clientTop) + el.offsetHeight,
      left: (box.left + window.pageXOffset - docElem.clientLeft) +  + el.offsetWidth
    };
  }
}

export default PageTabs;
